<template>
  <div>
    <div class="flex flex-column items-center">
      <a :href="content.display_content_url" class="pointer">
        <img v-if="content.display_content_image" :src="'https://media.ucpa.com' + content.display_content_image" style="max-height: 200px; max-width;: 650px">
      </a>
      <p v-if="content.display_content_text" v-html="convertFieldHTMLContentToView(content.display_content_text)"></p>
    </div>
  </div>
</template>

<script>
import { convertFieldHTMLContentToView } from '@/mixins/utils';

export default {
  components: {},
  props: {
    content: {
      type: Object,
      default: () => {}
    }
  },
  setup () {
    return { convertFieldHTMLContentToView };
  }
};
</script>
